import React, { useCallback, useEffect, useState } from 'react';
import { Form } from 'antd';
import { getUploadList, uploadMultipleDocuments } from '@gtintel/platform-api';
import { COOKIE_NAMES } from '@gtintel/platform-constants';
import { getSessionStorageItem } from '@gtintel/platform-utils';
import { DOCUMENT_LIBRARY_CHAT_DIR } from '../../const';
import FileList from '../../molecules/File/List';
import UploadFiles from '../../molecules/File/Upload';
import { TabTitle } from './styles';

/*

chatFileReadonly mode is there so that we don't have to build chat files into the
new version of doc lib until the Chat production direction is confirmed

*/

export default function DocumentTab({
  project,
  chatFilesReadonly
}) {
  const [path, setPath] = useState('');
  const [files, setFiles] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [uploads, setUploads] = useState(0);
  const user = getSessionStorageItem(COOKIE_NAMES.INFOR_USER);
  const partner = user?.is_network_partner;
  const isUploadingDisabled = chatFilesReadonly || path.startsWith(DOCUMENT_LIBRARY_CHAT_DIR);
  const refreshFileList = useCallback(() => {
    setIsLoading(true);
    getUploadList({
      projectId: project.id,
      path
    }).then(res => {
      const files = res.map(file => {
        let extension = '';
        let name = '';
        const isFolder = !file.file;
        if (!isFolder) {
          extension = /(?:\.([^.]+))?$/.exec(file.path)[1];
          name = file.path.split('/').pop();
        } else {
          extension = 'folder';
          name = file.path.slice(0, -1).split('/').pop();
        }
        return {
          date_uploaded: file.updated_at,
          extension,
          link: file.file,
          id: file.id,
          key: file.id,
          members: file.members,
          name,
          creator: file.creator,
          path: file.path
        };
      });
      setFiles(files);
      setIsLoading(false);
    }).catch(() => setIsLoading(false));
  }, [path, project.id, setFiles, setIsLoading]);
  useEffect(() => {
    refreshFileList();
  }, [refreshFileList]);
  return <Form.Item className="group-button" data-testid="document-library">
      {!chatFilesReadonly && <>
          <TabTitle data-public level={4}>
            Upload Your Files
          </TabTitle>
          <UploadFiles uploadDocuments={async file => {
        const data = new FormData();
        let success = false;
        let message = '';
        data.append('project_id', String(project.id));
        const fileName = file.webkitRelativePath !== '' ? file.webkitRelativePath : file.name;
        data.append(path + fileName, file);
        await uploadMultipleDocuments(data).then(() => {
          refreshFileList();
          setUploads(prevUploadStep => prevUploadStep + 1);
          success = true;
        }).catch(error => {
          success = false;
          message = error.data.message;
        });
        return {
          success,
          message
        };
      }} path={path} uploads={uploads} isUserNP={partner} />
        </>}
      <FileList isUploadingDisabled={isUploadingDisabled} files={files} isLoading={isLoading} isProjectAnonymous={project.request_anonymity} path={path} projectId={project.id} refreshFileList={refreshFileList} setPath={setPath} chatFilesReadonly={chatFilesReadonly} />
    </Form.Item>;
}